export const buildTemplateExportData = (template = {}) => ({
  name: template.name || template.template_title,
  description: template.description || template.template_description,
  template_image: template.template_image || '',
  project_description: template.project_description || '',
  project_goal: template.project_goal || '',
  tags: template.tags || '',
  actions: template.actions || '',
  workflow_flows: template.workflow_flows || '',
  widgets: template.widgets || '',
  model_preferences: template.model_preferences || '',
  embedded_plugins: template.embedded_plugins || '',
  datasource_suggestions: template.datasource_suggestions || '',
  process_on_file_change: template.process_on_file_change,
  enable_multi_docs_split: template.enable_multi_docs_split,
  file_ingestion_filters: template.file_ingestion_filters,
  prefer_image_creation_time: template.prefer_image_creation_time,
  show_calendar_widget: template.show_calendar_widget,
  show_trend_widget: template.show_trend_widget,
  version: template.version || 1,
  created_at: template.created_at,
});

export const buildTemplateDownloadFilename = (template = {}, date = new Date()) => {
  const templateName = String(template.name || template.template_title || 'template')
    .normalize('NFKC')
    .replace(/[<>:"/\\|?*]/g, '_')
    .split('')
    .filter((character) => character.charCodeAt(0) >= 32)
    .join('')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[. ]+$/g, '')
    || 'template';
  const datePart = date.toISOString().split('T')[0];
  return `${templateName}_${datePart}.json`;
};
